import React from 'react';
import {
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import ModalLayout from 'commons/components/ModalLayout';
import { formatDateSlash } from 'utils/dateHelpers';

const lsParams = { maximumFractionDigits: 2, minimumFractionDigits: 2 };

const ModalSelectCost = function (props) {
  const { open, costChoice, actions, convertZcotValue, currencyCode } = props;
  const { selected, zcotProjectedCost, zcorVersion, refresh, material } = costChoice;

  const handleChange = (e) => {
    actions.changeCostChoice(e.target.value);
  };

  const handleAccept = () => {
    actions.confirmCostChoice();
  };

  return (
    <ModalLayout open={open} toggleModalFnc={() => {}} width="500px" maxWidth="90%">
      <Typography variant="h5" mb="20px">
        Seleccione una opción
      </Typography>
      {refresh && (
        <Typography mb="20px">
          {`El material ${material} tiene una versión ZCOR más reciente que la usada en esta cotización. Confirme qué costo usar.`}
        </Typography>
      )}
      <FormControl>
        <RadioGroup value={selected} onChange={handleChange}>
          <FormControlLabel
            value="ZCOT"
            control={<Radio />}
            label={`Mantener Precio ZCOT (${currencyCode} ${convertZcotValue(
              zcotProjectedCost,
            ).toLocaleString('es-CL', lsParams)})`}
          />
          {zcorVersion && (
            <FormControlLabel
              value="ZCOR"
              control={<Radio />}
              label={`Considerar Ult.Version ${zcorVersion.versionLabel} del ${formatDateSlash(
                zcorVersion.versionDate,
              )} (${currencyCode} ${convertZcotValue(zcorVersion.totalProjectedCost).toLocaleString(
                'es-CL',
                lsParams,
              )})`}
            />
          )}
        </RadioGroup>
      </FormControl>
      <Grid container justifyContent="flex-end" mt="20px">
        <Button variant="contained" onClick={handleAccept}>
          Aceptar
        </Button>
      </Grid>
    </ModalLayout>
  );
};

export default ModalSelectCost;
